<script setup>
defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {}
    },
  },
})
</script>

<template>
  <section>
    <BaseContainer class="my-10 lg:my-20">
      <header v-if="content?.title" class="flex justify-center">
        <h3
          class="mb-4 mt-6 text-center font-heading text-5xl-nlh uppercase leading-verytight text-secondary md:mb-16"
        >
          {{ content?.title }}
        </h3>
      </header>
      <div
        v-if="content?.items && content?.items.length"
        class="flex flex-wrap justify-center gap-y-5 sm:-mx-5 sm:gap-y-10"
      >
        <div
          v-for="(card, index) of content.items"
          :key="index"
          class="w-full sm:w-1/2 sm:px-5 lg:w-1/3"
        >
          <BaseCard
            :content="card"
            :theme="card?.style.toLowerCase()"
            :centered="card?.centered"
            :truncate="false"
          />
        </div>
      </div>
    </BaseContainer>
  </section>
</template>
